/**
 * 流式输出内容不完整时，不通类型组件集合
 * zxw
 * 创建时间：2026-04-08
 */

import { CodeHighlighter, Mermaid } from '@ant-design/x';
import { Skeleton } from 'antd';

// 图片组件
export const ImageSkeleton = () => <Skeleton.Image active style={{ width: 60, height: 60 }} />;

// 链接组件
export const IncompleteLink = props => {
    const text = decodeURIComponent(String(props['data-raw'] || ''));
    // 提取链接文本，格式为 [text](url)
    const linkTextMatch = text.match(/^\[([^\]]*)\]/);
    const displayText = linkTextMatch ? linkTextMatch[1] : text.slice(1);
    return (
        <a style={{ pointerEvents: 'none' }} href="#">
            {displayText}
        </a>
    );
};

// 表格组件
export const TableSkeleton = () => <Skeleton.Node active style={{ width: 160 }} />;
// 网页组件
export const HtmlSkeleton = () => <Skeleton.Node active style={{ width: 383, height: 120 }} />;
// 加粗组件
export const IncompleteEmphasis = props => {
    const text = decodeURIComponent(String(props['data-raw'] || ''));
    const match = text.match(/^([*_]{1,3})([^*_]*)/);
    if (!match || !match[2]) return null;
    const [, symbols, content] = match;
    const level = symbols.length;
    switch (level) {
        case 1:
            return <em>{content}</em>;
        case 2:
            return <strong>{content}</strong>;
        case 3:
            return (
                <em>
                    <strong>{content}</strong>
                </em>
            );
        default:
            return null;
    }
};

// 代码组件
export const IncompleteInlineCode = props => {
    var _a;
    const rawData = String(props['data-raw'] || '');
    if (!rawData) return null;
    const decodedText =
        (_a = decodeURIComponent(rawData)) === null || _a === void 0 ? void 0 : _a.slice(1);
    return <code className="inline-code">{decodedText}</code>;
};

// 欢迎组件
export const WelcomeCard = props => (
    <Welcome
        styles={{ icon: { flexShrink: 0 } }}
        icon={props['data-icon']}
        title={props.title}
        description={props['data-description']}
    />
);

// 代码高亮
export const Code = props => {
    var _a;
    const { className, children } = props;
    const lang =
        ((_a =
            className === null || className === void 0 ? void 0 : className.match(/language-(\w+)/)) ===
            null || _a === void 0
            ? void 0
            : _a[1]) || '';
    if (typeof children !== 'string') return null;
    if (lang === 'mermaid') return <Mermaid
        code={children}
    />;
    return <CodeHighlighter lang={lang}>{children}</CodeHighlighter>;
};
